import type { ComponentProps } from "react"
import { Select as SelectBase } from "@/v2-ui/select/base/SelectBase"

export type SelectProps = ComponentProps<typeof SelectBase>

function Select(props: SelectProps) {
  const { ...selectBaseProps } = props
  return <SelectBase {...selectBaseProps} />
}

export default Select
